import script from "./BaZi.vue?vue&type=script&setup=true&lang=js"
export * from "./BaZi.vue?vue&type=script&setup=true&lang=js"

import "./BaZi.vue?vue&type=style&index=0&id=4ca75b26&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ca75b26"]])

export default __exports__